import axios from 'axios';

import authUtil from './AuthorizationUtil';
import UtilityService from './UtilityService';
export interface IQueryParameter {
  Key: string;
  value: string;
}
axios.defaults.withCredentials = true;
export interface IApiConfig {
  apiBaseUrl: string;
  storageType: string;
}
let cancelToken;

export default {
  postJsonData: async (apiConfig: IApiConfig, apiControllerName: string, jsonBody: {}) => {
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const responce = await axios({
        method: 'post',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        data: jsonBody,
        headers: header,
      });
      return responce.data;
    } catch (error) {
      throw error;
    }
  },
  postJsonDataWithCancelToken: async (apiConfig: IApiConfig, apiControllerName: string, jsonBody: {}) => {
    //Check if there are any previous pending requests
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.');
    }

    //Save the cancel token for the current request
    cancelToken = axios.CancelToken.source();
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const responce = await axios({
        method: 'post',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        data: jsonBody,
        headers: header,
        cancelToken: cancelToken.token,
      });
      return responce.data;
    } catch (error) {
      throw error;
    }
  },
  postJsonDataToBaseURL: async (apiConfig: IApiConfig, apiControllerName: string, jsonBody: {}) => {
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const responce = await axios({
        method: 'post',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        data: jsonBody,
        headers: header,
      });
      return responce.data;
    } catch (error) {
      throw error;
    }
  },
  getJsonDataWithBody: async (apiConfig: IApiConfig, apiControllerName: string, jsonBody: any) => {
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const responce = await axios({
        method: 'get',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        data: jsonBody,
        headers: header,
      });
      return responce.data;
    } catch (error) {
      throw error;
    }
  },
  getJsonData: async (apiConfig: IApiConfig, apiControllerName: string) => {
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);

      const responce = await axios({
        method: 'get',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        headers: header,
        withCredentials: true,
      });
      return responce.data;
    } catch (error) {
      throw error;
    }
  },

  getJsonDataQueryParameters: async (
    apiConfig: IApiConfig,
    apiControllerName: string,
    parameter: IQueryParameter[],
  ) => {
    try {
      let query = '';
      if (parameter.length > 0) {
        query += '?';
        parameter.forEach((element) => {
          query += element.Key + '=' + element.value + '&';
        });
        query = query.substring(0, query.length - 1);
      }

      const header = await authUtil.getApiHeader(apiConfig.storageType, true);

      const responce = await axios({
        method: 'get',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName + query,
        headers: header,
      });
      return responce.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (apiConfig: IApiConfig, apiControllerName: string, id: any) => {
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const responce = await axios({
        method: 'delete',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName + '/' + id,
        headers: header,
      });
      return responce.data;
    } catch (error) {
      throw error;
    }
  },
  update: async (apiConfig: IApiConfig, apiControllerName: string, id: any, jsonBody: any) => {
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const responce = await axios({
        method: 'put',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName + '/' + id,
        data: jsonBody,
        headers: header,
        withCredentials: true,
      });
      return responce.data;
    } catch (error) {
      throw error;
    }
  },
  UploadFile: async (apiConfig: IApiConfig, apiControllerName: string, selectedFile: string | Blob) => {
    const formData = new FormData();
    formData.append('file', selectedFile);
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const response = await axios({
        method: 'post',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        data: formData,
        headers: header,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  UploadFileWithData: async (apiConfig: IApiConfig, apiControllerName: string, obj: { [x: string]: any | Blob }) => {
    const formData = new FormData();

    for (const key in obj) {
      if (obj[key] !== null) formData.append(key, obj[key]);
    }
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const response = await axios({
        method: 'post',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        data: formData,
        headers: header,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  UploadFileWithData_Put: async (
    apiConfig: IApiConfig,
    apiControllerName: string,
    obj: { [x: string]: any | Blob },
  ) => {
    const formData = new FormData();

    for (const key in obj) {
      if (obj[key] !== null) formData.append(key, obj[key]);
    }
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const response = await axios({
        method: 'put',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        data: formData,
        headers: header,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  PostFormData: async (apiConfig: IApiConfig, apiControllerName: string, obj: { [x: string]: any }) => {
    const formData = new FormData();

    for (const key in obj) {
      if (obj[key] !== null) formData.append(key, obj[key]);
    }
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const response = await axios({
        method: 'post',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        data: formData,
        headers: header,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  PostForm: async (apiConfig: IApiConfig, apiControllerName: string, formData: FormData) => {
    try {
      const header = await authUtil.getApiHeader(apiConfig.storageType, true);
      const response = await axios({
        method: 'post',
        url: apiConfig.apiBaseUrl + '/' + apiControllerName,
        data: formData,
        headers: header,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
